<template>
  <div>
    <div class="tournament">
      <div class="quarters">
        <div class="title">Quarter-Finals</div>
        <Match :red="athletes[0]" :blue="athletes[1]"/>
        <div class="spacer-100"></div>
        <Match :red="athletes[2]" :blue="athletes[3]"/>
        <div class="spacer-100"></div>
        <Match :red="athletes[4]" :blue="athletes[5]"/>
        <div class="spacer-100"></div>
        <Match :red="athletes[6]" :blue="athletes[7]"/>
      </div>
      <div class="connection">
        <div class="spacer-50"></div>
        <div class="line"></div>
        <div class="spacer-100"></div>
        <div class="line"></div>
        <div class="spacer-100"></div>
        <div class="line"></div>
        <div class="spacer-100"></div>
        <div class="line"></div>
      </div>
      <div class="verticals">
        <div class="spacer-100"></div>
        <div class="vertical"></div>
        <div class="spacer-200"></div>
        <div class="vertical"></div>
      </div>
      <div class="connection">
        <div class="spacer-50"></div>
        <div class="spacer-100"></div>
        <div class="line"></div>
        <div class="spacer-300"></div>
        <div class="line"></div>
      </div>
      <div class="halfs">
        <div class="title">Half-Finals</div>
        <div class="spacer-100"></div>
        <Match :red="athletes[0]" :blue="athletes[2]"/>
        <div class="spacer-300"></div>
        <Match :red="athletes[5]" :blue="athletes[7]"/>
      </div>
      <div class="connection">
        <div class="spacer-50"></div>
        <div class="spacer-100"></div>
        <div class="line"></div>
        <div class="spacer-300"></div>
        <div class="line"></div>
      </div>
      <div class="verticals">
        <div class="spacer-200"></div>
        <div class="vertical"></div>
        <div class="vertical"></div>
      </div>
      <div class="connection">
        <div class="spacer-50"></div>
        <div class="spacer-300"></div>
        <div class="line"></div>
      </div>
      <div class="finals">
        <div class="title">Finals</div>
        <div class="spacer-300"></div>
        <Match :red="athletes[0]" :blue="athletes[5]"/>
      </div>
    </div>
  </div>

</template>

<script>
import Match from './Match.vue';

export default {
  name: 'Brackets',
  components: { Match },
  data() {
    return {
      athletes: [
        {
          athlete: 'Alpha',
          team: 'A Team',
        },
        {
          athlete: 'Bravo',
          team: 'B Team',
        },
        {
          athlete: 'Charlie',
          team: 'C Team',
        },
        {
          athlete: 'Delta',
          team: 'D Team',
        },
        {
          athlete: 'Echo',
          team: 'E Team',
        },
        {
          athlete: 'Foxtrot',
          team: 'F Team',
        },
        {
          athlete: 'Gamma',
          team: 'G Team',
        },
        {
          athlete: 'Husky',
          team: 'H Team',
        },
      ],
    };
  },
};

</script>

<style scoped>
  .tournament {
    display: flex;
    flex-direction: row;
  }

  .title {
    font-weight: bold;
    font-size: 150%;
  }

  .spacer-50, .title {
    height: 50px;
  }

  .spacer-100 {
    height: 100px;
  }

  .spacer-200 {
    height: 200px;
  }

  .spacer-300 {
    height: 300px;
  }

  .connection {
    flex-grow: 1;
  }

  .line {
    border: 1px solid gray;
    margin: 49px 0px;
  }

  .vertical {
    height: 200px;
    border: 1px solid gray;
  }
</style>
